import { render, staticRenderFns } from "./JudgementCreditorBankDetails.vue?vue&type=template&id=3a2474ed&scoped=true&"
import script from "./JudgementCreditorBankDetails.vue?vue&type=script&lang=js&"
export * from "./JudgementCreditorBankDetails.vue?vue&type=script&lang=js&"
import style0 from "./JudgementCreditorBankDetails.vue?vue&type=style&index=0&id=3a2474ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2474ed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VContainer,VIcon,VRadio,VRadioGroup,VRow,VTextField,VTextarea})
